import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Wifi, CreditCard, CheckCircle, XCircle, AlertTriangle } from "lucide-react";

export default function Integrations() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/integrations/status").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-gray-400">Yükleniyor...</div>;

  const Row = ({ label, ok, extra }) => (
    <div className="flex items-center justify-between py-2 border-b border-white/5">
      <span className="text-sm text-gray-300">{label}</span>
      <span className={`flex items-center gap-1 text-sm font-semibold ${ok ? "text-green-400" : "text-red-400"}`}>
        {ok ? <CheckCircle size={15} /> : <XCircle size={15} />}{extra || (ok ? "Aktif" : "Yok")}
      </span>
    </div>
  );

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-extrabold text-white mb-6">Entegrasyonlar</h1>
      <div className="card-surface p-6 mb-4">
        <div className="flex items-center gap-2 mb-4"><Wifi size={18} className="text-[#d8b4fe]" /><h3 className="font-bold text-white">JungleSMM API</h3></div>
        <Row label="Bağlantı Durumu" ok={s.jungle.connected} extra={s.jungle.connected ? "Bağlı" : "Bağlantı Yok"} />
        {s.jungle.balance && <Row label="Bakiye" ok={true} extra={s.jungle.balance} />}
        {s.jungle.error && <div className="flex items-center gap-2 text-sm text-yellow-400 mt-3"><AlertTriangle size={15} /> {s.jungle.error}</div>}
        <p className="text-xs text-gray-500 mt-3">API anahtarı backend Environment Variables içinde güvenli şekilde saklanır (JUNGLE_SMM_API_KEY).</p>
      </div>
      <div className="card-surface p-6">
        <div className="flex items-center gap-2 mb-4"><CreditCard size={18} className="text-[#d8b4fe]" /><h3 className="font-bold text-white">Shopier Ödeme</h3></div>
        <Row label="PAT Token" ok={s.shopier.configured} extra={s.shopier.configured ? "Yapılandırıldı" : "Yok"} />
        <Row label="Webhook Token" ok={s.shopier.webhook_token_set} extra={s.shopier.webhook_token_set ? "Ayarlandı" : "Ayarlanmadı"} />
        <Row label="Shop Slug" ok={s.shopier.shop_slug_set} extra={s.shopier.shop_slug_set ? "Ayarlandı" : "Ayarlanmadı"} />
        <div className="bg-yellow-500/10 text-yellow-300 text-xs rounded-xl p-4 mt-4 leading-relaxed">
          <b>Not:</b> Otomatik sipariş için Shopier panelinizden webhook URL'sini <code className="bg-black/30 px-1 rounded">{process.env.REACT_APP_BACKEND_URL}/api/webhooks/shopier</code> olarak ekleyin ve <code>SHOPIER_WEBHOOK_TOKEN</code> ile <code>SHOPIER_SHOP_SLUG</code> değerlerini Environment Variables içine girin. Webhook doğrulanmadan JungleSMM'e sipariş gönderilmez.
        </div>
      </div>
    </div>
  );
}
